import { render, staticRenderFns } from "./TablePreviewImport.vue?vue&type=template&id=34f4cb3c&scoped=true"
import script from "./TablePreviewImport.vue?vue&type=script&lang=js"
export * from "./TablePreviewImport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34f4cb3c",
  null
  
)

export default component.exports